import invariant from 'tiny-invariant'

export const CF_URL = process.env.NEXT_PUBLIC_CF_URL || process.env.VITE_CF_URL

invariant(CF_URL, 'NEXT_PUBLIC_CF_URL or VITE_CF_URL is required for nonce functionality')

/**
 * Fetches a security nonce from the server for a specific action
 * @param nonceType - The nonce type identifier string
 * @returns Promise that resolves to the nonce string
 */
export async function fetchNonce(nonceType: string): Promise<string> {
  const body = JSON.stringify({
    nonce: nonceType,
  })

  const headers = new Headers()
  headers.append('accept', 'application/json, multipart/mixed')
  headers.append('content-type', 'application/json')

  try {
    const res = await fetch(`${CF_URL}/cfsecure/nonce`, {
      method: 'POST',
      credentials: 'include',
      headers,
      body,
    })

    const textResponse = await res.text()

    try {
      const fetchData = JSON.parse(textResponse)
      return fetchData.nonce
      // oxlint-disable-next-line unicorn/catch-error-name
    } catch (err) {
      throw new Error('Nonce response is not JSON')
    }
    // oxlint-disable-next-line unicorn/catch-error-name
  } catch (er) {
    throw new Error(`Failed to fetch nonce for ${nonceType}`)
  }
}

/**
 * React hook for fetching nonces within components
 * @param onError - Optional error handler callback
 * @returns Object with getNonce function
 */
export function useNonce(onError?: (error: Error) => void) {
  /**
   * Gets a nonce for the specified action type
   * @param nonceType - The nonce type identifier string
   * @returns Promise that resolves to the nonce string
   */
  const getNonce = async (nonceType: string): Promise<string> => {
    try {
      return await fetchNonce(nonceType)
    } catch (error) {
      if (onError && error instanceof Error) {
        onError(error)
      }
      throw error
    }
  }

  return { getNonce }
}
